<template>
  <router-link
    :to="{name: 'sequence_level_var', params: {sequence_id: levelVarId.sequenceProtoId, level_num: levelVarId.number, level_id: levelVarId.protoId}, query: queryObject}"
  >
    <slot>{{levelVarName}}</slot>
  </router-link>
</template>

<script>
import { getLevelVarName                  } from '../../model/m3level.js';
import { convertOptionalValueToQueryParam } from '../../util.js';

export default {
  name: 'LevelVarLink',

  props: {
    levelVarId: {
      type: Object,
      required: true,
    },

    audienceId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    levelVarName() {
      return getLevelVarName(this.levelVarId.protoId);
    },

    queryObject() {
      return {
        audience: convertOptionalValueToQueryParam(this.audienceId),
      };
    },
  },
}
</script>
